"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.VALID_PATIENT_RELATIONSHIPS = void 0;
var _Filters = require("./Filters");
const VALID_PATIENT_RELATIONSHIPS = exports.VALID_PATIENT_RELATIONSHIPS = [_Filters.NEW_PATIENT, _Filters.ESTABLISHED_PATIENT];